import { captureException } from "@sentry/react";
import { _Activity } from "@src/Steps/simulate/activities/Activities";
import ACTIVITES from "@src/Steps/simulate/activities/activitiesConfig";
import axios from "axios";
import { format, getYear } from "date-fns"; // eslint-disable-line import/no-duplicates
import { useEffect, useMemo, useState } from "react";
import fr from "date-fns/locale/fr"; // eslint-disable-line import/no-duplicates

import { Desktop, Mobile } from "@lya-protect/lya-protect-form-library/dist/UI";
import { GarantieAssistanceModal } from "@src/components/garanties/GarantieAssistanceModal";
import { GarantieProtectionJuridiqueModal } from "@src/components/garanties/GarantieProtectionJuridique";
import { LoaderOverlay } from "@src/components/loaderOverlay/LoaderOverlay";
import { Modal } from "@src/components/modal/Modal";
import { displayToast } from "@src/components/toaster/Toaster";
import { StepProps } from "../../step/Steps";
import { TarifDesktop } from "./TarifDesktop";
import { TarifMobile } from "./TarifMobile";

type TarifResponse = Tarif[];

export type Tarif = {
  name: string;
  capitalForfaitaire: string;
  renteMensuelle: string;
  simulationCotisation: number;
};

type LandingProps = StepProps<Tarif | undefined>;

export function Tarif({ changeStep, setData, stepsData }: LandingProps) {
  const [tarifs, setTarifs] = useState<TarifResponse>();
  const [modalGassitanceIsOpen, setModalGassitanceIsOpen] = useState(false);
  const [modalPJuridiqueIsOpen, setModalPJuridiqueIsOpen] = useState(false);
  const [renderIsComplete, setRenderIsComplete] = useState(false);

  const age =
    stepsData.BIRTHDATE.birthDate &&
    getYear(new Date()) - getYear(stepsData.BIRTHDATE.birthDate);

  const selectTarif = (tarif: Tarif) => () => {
    setData(tarif);
    changeStep("CONTACT_INFOS", "forward");
  };

  useEffect(() => {
    axios
      .post<TarifResponse>(`//${process.env.VITE_URL_GATEWAY}/tarif`, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        birthDate: format(stepsData.BIRTHDATE.birthDate!, "yyyy-MM-dd", {
          locale: fr,
        }),
        adherent: stepsData.SITUATION?.isMemberTutelaire,
      })
      .then(({ data }) => {
        setTarifs(data);
      })
      .catch((err) => {
        displayToast("Une erreur inconnue est survenue", "error");
        changeStep("ACTIVITIES", "backward");
        captureException(err);
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (tarifs && age !== undefined) setRenderIsComplete(true);
  }, [tarifs]);

  const visibleActivities = useMemo(
    () =>
      ACTIVITES.filter(
        (activity: _Activity) => stepsData.ACTIVITIES[activity.name]
      ),
    [stepsData.ACTIVITIES]
  );

  return (
    <>
      <LoaderOverlay isLoading={!renderIsComplete} />
      {tarifs && age !== undefined && (
        <>
          <Desktop>
            <TarifDesktop
              tarifs={tarifs}
              selectTarif={selectTarif}
              changeStep={changeStep}
              openModalGassistance={() => setModalGassitanceIsOpen(true)}
              visibleActivities={visibleActivities}
            />
          </Desktop>
          <Mobile>
            <TarifMobile
              tarifs={tarifs}
              selectTarif={selectTarif}
              changeStep={changeStep}
              openModalGassistance={() => setModalGassitanceIsOpen(true)}
              visibleActivities={visibleActivities}
            />
          </Mobile>
        </>
      )}
      <Modal
        isOpen={modalGassitanceIsOpen}
        Content={GarantieAssistanceModal}
        close={() => setModalGassitanceIsOpen(false)}
      />
      <Modal
        isOpen={modalPJuridiqueIsOpen}
        Content={GarantieProtectionJuridiqueModal}
        close={() => setModalPJuridiqueIsOpen(false)}
      />
    </>
  );
}
